"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const weave_1 = require("../../../app/dist/weave");
const thread_1 = require("../../../app/dist/thread");
const weaveIdea_1 = require("../../../app/dist/weaveIdea");
const weavePlan_1 = require("../../../app/dist/weavePlan");
// Composes the existing app create use-cases (mcp → app) to seed one tiny,
// obviously-a-demo weave→thread→idea→plan so a brand-new workspace shows the
// shape instead of an empty tree. Opt-in only (the extension's "Start with an
// example" button), never run on install (EX3).
const IDEA_BODY = `## What

A tiny worked example so you can see Loom's shape end to end: a **weave** (project
area) → **thread** (workstream) → **idea** → **plan** with steps.

Delete this whole \`example\` weave whenever you like — it exists only to show the loop.

## Why it matters

New workspaces start empty, which reads as "nothing works". Seeing a real graph —
idea, then a plan with concrete steps — makes the workflow obvious in ten seconds.

## Success

You can open each doc, run *Generate Design* / *Generate Plan* / *Do Step* on your
own threads, and understand what each produces.`;
exports.toolDef = {
    name: 'loom_seed_example',
    description: "Seed one tiny, clearly-labelled example weave→thread→idea→plan into the workspace at LOOM_ROOT, so a brand-new Loom workspace shows the shape (idea → plan → steps) instead of an empty tree. Opt-in only — the VS Code extension's empty-state 'Start with an example' button calls this; it is NEVER run automatically on install. Creates a weave named 'example' the user can delete at any time. Returns the created ids.",
    inputSchema: {
        type: 'object',
        properties: {},
        required: [],
    },
};
async function handle(root, _args) {
    const weaveSlug = 'example';
    await (0, weave_1.createWeave)({ weaveSlug }, { getActiveLoomRoot: () => root, fs });
    const thread = await (0, thread_1.createThread)({ weaveSlug, threadSlug: 'first-feature', title: 'First Feature' }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, fs });
    const threadUlid = thread.id;
    const idea = await (0, weaveIdea_1.weaveIdea)({ weaveSlug, threadUlid, title: 'Example: how a Loom thread fits together', content: IDEA_BODY }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs });
    const plan = await (0, weavePlan_1.weavePlan)({
        weaveSlug,
        threadUlid,
        title: 'Build the example feature',
        goal: 'A throwaway two-step plan so you can see how steps, files, and done-notes work. Run *Start Plan* then *Do Step* on it, or just delete the example weave.',
        steps: [
            { description: 'Read the idea and the design (if generated), then note the intended behaviour.', title: 'Understand the idea' },
            { description: 'Implement the feature and record what changed in the done note.', title: 'Implement', blockedBy: [] },
        ],
    }, { loadWeave: dist_1.loadWeave, saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs, loomRoot: root });
    return {
        content: [{
                type: 'text',
                text: JSON.stringify({ weaveSlug, threadUlid, ideaId: idea.id, planId: plan.id }),
            }],
    };
}
